import ReactCodeMirror, { DecorationSet, EditorState, EditorView } from '@uiw/react-codemirror'
import { Input } from '@common/ui/mantine'
import React from 'react'
import { com } from '@eidu/web'
import ValidFieldNamesContext from '../misc/ValidFieldNamesContext'
import highlightFieldReferences from '../misc/highlightFieldReferences'
import { labelLineToString } from '../misc/LabelUtil'
import Field = com.eidu.entity.field.Field
import EntityLabelLine = com.eidu.entity.label.EntityLabelLine

const LabelFormatDisplay = ({ value }: { value: string }) => {
  const singleLineExtension = EditorState.transactionFilter.of((transaction) => {
    if (transaction.newDoc.lines > 1) {
      return []
    }
    return transaction
  })

  const validFieldNames = React.useContext(ValidFieldNamesContext)

  const highlightExtension = EditorView.decorations.of(
    (view: EditorView): DecorationSet => highlightFieldReferences(view, validFieldNames)
  )

  const theme = EditorView.theme({
    '&': {
      paddingTop: '1.2ex',
      paddingBottom: '1.2ex',
      paddingLeft: '0.8ex',
      paddingRight: '0.8ex',
    },
    '&.cm-editor.cm-focused': {
      outline: 'none',
    },
  })

  return (
    <ReactCodeMirror
      style={{ display: 'block', width: '100%' }}
      value={value}
      basicSetup={{
        foldGutter: false,
        lineNumbers: false,
        highlightActiveLine: false,
      }}
      indentWithTab={false}
      extensions={[theme, singleLineExtension, highlightExtension]}
      editable={false}
    />
  )
}

export type LabelLineDisplayProps = {
  title: string
  label: EntityLabelLine | undefined
  availableFields: readonly Field[]
}

const LabelLineDisplay = ({ title, label, availableFields }: LabelLineDisplayProps) => {
  const validFieldNames = availableFields.map((it) => it.name)
  return (
    <ValidFieldNamesContext.Provider value={validFieldNames}>
      <Input.Wrapper label={title}>
        <div
          style={{
            border: '1px solid var(--trellis-color-text-disabled)',
            borderRadius: 'var(--trellis-radius-sm)',
            overflow: 'hidden',
          }}
        >
          <LabelFormatDisplay value={label ? labelLineToString(label, availableFields) : ''} />
        </div>
      </Input.Wrapper>
    </ValidFieldNamesContext.Provider>
  )
}

export default LabelLineDisplay
